import { render } from "./ModuleGrid.vue?vue&type=template&id=79159875&scoped=true&ts=true"
import script from "./ModuleGrid.vue?vue&type=script&lang=ts"
export * from "./ModuleGrid.vue?vue&type=script&lang=ts"

import "./ModuleGrid.vue?vue&type=style&index=0&id=79159875&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79159875"]])

export default __exports__